import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { IPromoModalProps } from '@cian/frontend-newbuilding-promo-modal-widget';
import { useNewbuildingLinks } from './useNewbuildingLinks';
import { selectPromoDetails } from '../../../selectors/promoDetails';

export const usePreparedPromo = (): IPromoModalProps['promo'] | null => {
  const promo = useSelector(selectPromoDetails);
  const availableJks = useNewbuildingLinks(promo);

  return useMemo(() => {
    if (!promo) {
      return null;
    }

    return {
      authorName: promo.formattedBuilderName ? `Застройщик ${promo.formattedBuilderName}` : promo.providerName,
      authorLogo: promo.providerLogo,
      name: promo.promoName,
      type: promo.promoType,
      features: promo.promoModalProps.map(prop => ({
        name: prop.title,
        value: prop.value,
        valueChange: prop.valueChange,
        type: prop.type,
      })),
      banks: promo.banks.map((bank, i) => ({
        id: i,
        name: bank.name,
        logoUrl: bank.logo,
      })),
      description: promo.promoDescription,
      availableJks,
      labels: promo.labels,
      availablePurchaseTerms: promo.availablePurchaseTerms,
      mortgageLegalInfo: promo.promoLegalTerms,
      cianMortgageButton: promo.button,
      creditTerms: promo.creditTerms,
      isBankMortgage: promo.isBankMortgage,
    } as IPromoModalProps['promo'];
  }, [promo, availableJks]);
};
